module.exports = __webpack_public_path__ + "img/RORBPJR40004.2973aee7.png";